var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChart3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#FF6782",
    fillOpacity: 0.16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.46688 16C6.40288 16 6.34288 15.976 6.28688 15.928C6.23888 15.88 6.21488 15.82 6.21488 15.748L6.23888 15.64L9.13087 7.9C9.18687 7.7 9.32688 7.6 9.55088 7.6H10.8589C11.0669 7.6 11.2069 7.7 11.2789 7.9L14.1709 15.64C14.1789 15.664 14.1829 15.7 14.1829 15.748C14.1829 15.82 14.1589 15.88 14.1109 15.928C14.0629 15.976 14.0069 16 13.9429 16H12.8989C12.7949 16 12.7149 15.976 12.6589 15.928C12.6029 15.88 12.5669 15.828 12.5509 15.772L11.9869 14.308H8.42288L7.85888 15.772C7.79488 15.924 7.67888 16 7.51088 16H6.46688ZM11.5669 12.928L10.1989 9.22L8.84288 12.928H11.5669ZM15.5912 16C15.5112 16 15.4432 15.972 15.3872 15.916C15.3312 15.86 15.3032 15.792 15.3032 15.712V7.888C15.3032 7.8 15.3312 7.732 15.3872 7.684C15.4432 7.628 15.5112 7.6 15.5912 7.6H16.7192C16.8072 7.6 16.8752 7.628 16.9232 7.684C16.9792 7.732 17.0072 7.8 17.0072 7.888V15.712C17.0072 15.792 16.9792 15.86 16.9232 15.916C16.8752 15.972 16.8072 16 16.7192 16H15.5912Z",
    fill: "#F85B77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart3);
export default __webpack_public_path__ + "static/media/chart-3.8d055ab7fdf127c18ede608e94b1c40e.svg";
export { ForwardRef as ReactComponent };